<template>
  <div
    class="Payments"
    :class="'Orders--showCurrent-'+showCurrent">
    <h1>Payments</h1>
    <md-tabs>
      <md-tab
        v-on:click="showCurrent = true; init();"
        md-label="Payments Due">
      </md-tab>
      <md-tab
        v-on:click="showCurrent = false; getFulfilledOrders();"
        md-label="Previous payments">
      </md-tab>
    </md-tabs>
    {{mode}}

    <error v-if="asyncFormError" :message="errorMessage"></error>

    <div class="Orders-fulfilled" v-if="showCurrent && !asyncFormError">
      <p>{{ overview.date | moment("ddd, MMM Do YYYY") }}</p>
      <p>Total events: {{ overview.totalOrders }}</p>
      <p>Total due: <span v-for="chip in getOverviewCurrencyChip()" :key="chip.symbol" :class="chip.class" style="margin-right: 4px;">{{ chip.symbol }}</span>{{ overview.totalPrice }}</p>
      <p v-if="user && user.stripe_connect">
        Stripe Connect: 
        <span v-if="currentStripeConnectStatus === 'connected'" class="Chip Chip--success">
          Connected
        </span>
        <span v-else-if="currentStripeConnectStatus === 'pending'" class="Chip Chip--warning">
          Pending
        </span>
        <span v-else-if="currentStripeConnectStatus === 'hybrid'" class="Chip Chip--hybrid">
          Hybrid
        </span>
        <span v-else>Off</span><br>
        {{user.stripe_connect.stripe_account_id}}<br>
        Created: {{user.stripe_connect.created_at | moment('DD/MM/YYYY HH:mm')}}, Updated: {{user.stripe_connect.updated_at | moment('DD/MM/YYYY HH:mm')}}
      </p>
    </div>

    <!-- Filters for main payments list -->
    <div v-if="!showUserTable && showCurrent" class="payments-filters">
      <h3>Filters</h3>
      <div class="filter-controls">
        <div class="filter-group">
          <label>Stripe Status:</label>
          <select v-model="filters.stripeStatus" @change="applyFilters">
            <option value="all">All</option>
            <option value="connected">Connected</option>
            <option value="pending">Pending</option>
            <option value="hybrid">Hybrid</option>
            <option value="off">Off</option>
          </select>
        </div>
        
        <div class="filter-group">
          <label>Bank Details:</label>
          <select v-model="filters.bankDetails" @change="applyFilters">
            <option value="all">All</option>
            <option value="has">Has Details</option>
            <option value="missing">Missing Details</option>
          </select>
        </div>
        
        <div class="filter-group">
          <label>View:</label>
          <select v-model="filters.view" @change="applyFilters">
            <option value="default">Default</option>
            <option value="stripe-only">Stripe Connected Only</option>
            <option value="hybrid-only">Hybrid Only</option>
            <option value="bank-only">With Bank Details Only</option>
            <option value="both">Stripe + Bank Details</option>
          </select>
        </div>
        
        <button class="Button" @click="clearFilters">Clear Filters</button>
      </div>
      
      <div class="filter-summary" v-if="hasActiveFilters">
        <p>Showing {{ filteredUserData.length }} of {{ userData.length }} users</p>
      </div>
    </div>


    <ve-table
      v-if="showUserTable"
      class="Payments-table"
      :fixed-header="true"
      :columns="userColumns"
      :table-data="[user]"
      :cell-style-option="cellStyleOption"
      :rowStyleOption="rowStyleOption"
      :expand-option="expandOption"
    />


    <!-- Keyboard shortcuts indicator -->
    <div v-if="showUserTable" class="keyboard-shortcuts">
      <h3>Keyboard Shortcuts:</h3>
      <div class="shortcut-grid">
        <div class="shortcut-item" :class="{ 'active': lastPressedKey === '1' }">
          <span class="key">1</span>
          <span class="label">Copy Email</span>
          <span v-if="lastPressedKey === '1'" class="copied-value">{{ copiedValue }}</span>
        </div>
        <div class="shortcut-item" :class="{ 'active': lastPressedKey === '2' }">
          <span class="key">2</span>
          <span class="label">Copy Account Number</span>
          <span v-if="lastPressedKey === '2'" class="copied-value">{{ copiedValue }}</span>
        </div>
        <div class="shortcut-item" :class="{ 'active': lastPressedKey === '3' }">
          <span class="key">3</span>
          <span class="label">Copy Amount</span>
          <span v-if="lastPressedKey === '3'" class="copied-value">{{ copiedValue }}</span>
        </div>
        <div class="shortcut-item" :class="{ 'active': lastPressedKey === '4' }">
          <span class="key">4</span>
          <span class="label">Copy Table</span>
          <span v-if="lastPressedKey === '4'" class="copied-value">Table copied to clipboard</span>
        </div>
        <div class="shortcut-item" :class="{ 'active': lastPressedKey === 'p' || lastPressedKey === 'P' }">
          <span class="key">P</span>
          <span class="label">Mark as Paid</span>
          <span v-if="lastPressedKey === 'p' || lastPressedKey === 'P'" class="copied-value">Marking as paid...</span>
        </div>
      </div>
    </div>

    <ve-table
      ref="paymentsDueElement"
      class="Payments-table"
      :fixed-header="true"
      :columns="columnSource"
      :table-data="dataSource"
      :cell-style-option="cellStyleOption"
      :rowStyleOption="rowStyleOption"
      :expand-option="expandOption"
    />

    <button
      v-if="showUserTable"
      class="Button u-floatRight u-marginBottom u-marginLeft"
      v-on:click="markAsPaid()">
      Mark as paid [p]
    </button>

  </div>
</template>

<script>
import './payments.scss';
import axios from 'axios';
import cookieModel from '../../models/cookie';
import {clone} from "lodash";

const TicketTable = {
  name: "TicketTable",
  template: `
    <div class="child-table-comp">
    <span style="font-weight:bold;">Table Name:{{ row.name }}</span>
    <ve-table
      style="width:100%"
      :columns="ticketColumns"
      :table-data="row.tickets"
    />
    </div>
  `,
  props: {
    row: Object,
    stripeConnectUpdated: Date
  },
  data() {
    return {
      ticketColumns: [
        {
          field: "id",
          key: "id",
          title: "ID"
        },
        {
          field: "name",
          key: "b",
          title: "Name"
        },
        {
          field: "email",
          key: "c",
          title: "Email",
          align: "left"
        },
        {
          field: "code",
          key: "d",
          title: "Code"
        },
        {
          field: "quantity",
          key: "e",
          title: "Quantity"
        },
        {
          field: "type",
          key: "type",
          title: "Type"
        },
        {
          field: "currency",
          key: "currency",
          title: "Currency",
          align: "center",
          renderBodyCell: ({row}, h) => {
            if (row.currency_symbol) {
              // Currency mapping function (moved inline to avoid this context issues)
              const getCurrencyChipClass = (currencySymbol) => {
                const currencyMap = {
                  '£': 'gbp',
                  '$': 'usd',
                  '€': 'eur',
                  'C$': 'cad',
                  'A$': 'aud',
                  '¥': 'jpy',
                  'CHF': 'chf'
                };
                
                // Find the matching currency
                for (const [symbol, chipClass] of Object.entries(currencyMap)) {
                  if (currencySymbol === symbol) {
                    return `Chip Chip--${chipClass}`;
                  }
                }
                
                // Default fallback
                return 'Chip Chip--default';
              };

              return h('span', {
                class: getCurrencyChipClass(row.currency_symbol)
              }, row.currency_symbol);
            }
            return null;
          },
        },
        {
          field: "discount_code",
          key: "f",
          title: "Discount code",
          renderBodyCell: ({row}, h) => {
            if (row.discount_code) {
              return h('span', {}, 
                `${row.discount_code.id}: ${row.discount_code.code} (${row.discount_code.type} ${row.discount_code.amount})`
              );
            }
            return null;
          },
        },
        {
          field: "timestamp",
          key: "g",
          title: "Timestamp"
        },
        {
          field: "",
          key: "h",
          title: "Payment Status",
          renderBodyCell: ({row}, h) => {
            if (
              row.user &&
              row.user.stripe_connect &&
              row.user.stripe_connect.status === 1 &&
              row.user.stripe_connect.updated_at > row.timestamp) {
              return h('span', { class: 'Chip Chip--success' }, 'Stripe Connected');
            }
            return null;
          },
        },
      ],
    };
  },
};

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    TicketTable
  },
  data() {
    // Store TicketTable reference for use in expandOption
    const ticketTableComponent = TicketTable
    return {
      ticketTableComponent: ticketTableComponent,
      baseUrl: process.env.VUE_APP_API_URL,
      venueId: process.env.VUE_APP_VENUE_ID,//cookieModel.getCookie("ticketlab_venue_id"),
      mode: process.env.VUE_APP_MODE,
      axiosInstance: axios.create({
        baseURL: this.baseUrl
      }),
      currentAccountDetails: {},
      payments: [],
      showUserTable: false,
      showCurrent: true,
      showTable: 'all',
      overview: {},
      asyncFormError: false,
      transferEnabled: false,
      columnSource: [],
      dataSource: [],
      user: {},
      lastPressedKey: null,
      copiedValue: '',
      filters: {
        stripeStatus: 'all',
        bankDetails: 'all',
        view: 'default'
      },
      eventColumns: [
        {
          field: "id",
          key: "id",
          title: "ID",
          align: "right",
          operationColumn: true,
          type: "expand",
        },
        {
          field: "name",
          key: "a",
          title: "Name",
          align: "left",
          renderBodyCell: ({row}, h) => {
            // Skip rendering link for Total row or rows without valid IDs
            if (row.id === 'Total' || !row.id || !row.name) {
              return h('span', {}, row.name || '');
            }
            
            // Construct URL from event ID if url is not provided
            const eventUrl = row.url || `https://ticketlab.co.uk/event/${row.id}`;
            
            return h('a', {
              attrs: {
                href: eventUrl,
                target: '_blank',
                rel: 'noopener noreferrer'
              },
              on: {
                click: (e) => {
                  // Stop propagation to prevent row click handlers from interfering
                  e.stopPropagation();
                }
              }
            }, row.name);
          },
        },
        {
          field: "date",
          key: "b",
          title: "Date",
          align: "left"
        },
        {
          field: "currency",
          key: "currency",
          title: "Currency",
          align: "center",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            if (row.currency_symbol) {
              return h('span', {
                class: this.getCurrencyChipClass(row.currency_symbol)
              }, row.currency_symbol);
            }
            return null;
          },
        },
        {
          field: "price",
          key: "c",
          title: "Price",
          align: "right",
          type: "currency",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return h('span', {}, `${row.currency_symbol}${row.price}${row.includes_booking_fee ? "*" : ""}`);
          },
        },
        {
          field: "sold",
          key: "d",
          title: "Quantity sold",
          align: "right"
        },
        {
          field: "owed",
          key: "f",
          title: "Paid",
          align: "right",
          type: "currency",
          /* eslint-disable no-unused-vars */ // h is required for renderBodyCell to work
          renderBodyCell: ({row}, h) => {
            return h('span', {}, `${row.currency_symbol}${row.owed}`);
          },
        },
      ],
      userColumns: [
        {
          field: "id",
          key: "id",
          title: "ID",
          align: "right",
        },
        {
          field: "forename",
          key: "a",
          title: "Forename",
          align: "left"
        },
        {
          field: "surname",
          key: "b",
          title: "Surname",
          align: "left"
        },
        {
          field: "company",
          key: "c",
          title: "Company",
          align: "left"
        },
        {
          field: "email",
          key: "email",
          title: "Email",
          align: "left"
        },
        {
          field: "stripe_connect_status",
          key: "d",
          title: "Stripe Connect Status",
          align: "left",
          renderBodyCell: ({row}, h) => {
            // Find the payment data for this user to check ticket timestamps
            const userPayment = this.payments.find(payment => payment.user && payment.user.id === row.id);
            const status = this.getStripeConnectStatus(row, userPayment);
            
            if (status === 'connected') {
              return h('span', { class: 'Chip Chip--success' }, 'Connected');
            } else if (status === 'pending') {
              return h('span', { class: 'Chip Chip--warning' }, 'Pending');
            } else if (status === 'hybrid') {
              return h('span', { class: 'Chip Chip--hybrid' }, 'Hybrid');
            }
            return null;
          }
        },
        {
          field: "",
          key: "e",
          title: "Account Details",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return this.renderAccountDetailsCell({row, column, rowIndex}, h);
          }
        },
        {
          field: "",
          key: "actions",
          title: "Action",
          width: "",
          center: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            // Hide the button when viewing individual user payments
            if (this.showUserTable) {
              return null;
            }
            const handleNavigation = (e) => {
              e.preventDefault();
              this.$router.push(`/payments/due/${row.id}`);
              this.init(row.id);
            };
            
            return h('span', {}, [
              h('a', {
                class: 'Button',
                style: 'color: #fff; text-decoration:none; cursor: pointer;',
                attrs: {
                  'data-view-payments-button': true,
                  'data-row-index': rowIndex,
                  tabindex: rowIndex === 0 ? '0' : '-1',
                  role: 'button'
                },
                ref: rowIndex === 0 ? 'firstViewPaymentsButton' : null,
                on: {
                  click: handleNavigation,
                  keydown: (e) => {
                    // Handle Enter and Space keys for keyboard navigation
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleNavigation(e);
                    }
                  }
                }
              }, 'View Payments')
            ]);
          }
        },
      ],
      cellStyleOption: {
        bodyCellClass: ({row, column}) => {
          if (column.type === "boolean") {
            if (row[column.field] === true) {
              return "isTrue";
            }
          }
        },
      },
      rowStyleOption: {
        clickHighlight: true,
        hoverHighlight: false,
      },
      expandOption: {
        render: ({row, column, rowIndex}, h) => {
          // Use the component from data to ensure it's in scope
          // eslint-disable-next-line vue/no-unused-components
          const TicketTableComponent = this.ticketTableComponent || TicketTable;
          return h('div', {}, [
            h(TicketTableComponent, {
              props: {
                row: row,
                stripeConnectUpdated: row.user?.stripe_connect?.updated_at
              }
            })
          ]);
        },
      },
      // edit option
      editOption: {
        beforeCellValueChange: ({row, column, changeValue}) => {
          if (column.field === "number" && !/^\d+$/.test(changeValue)) {
            alert("please enter a number");
            return false;
          }
        },
        afterCellValueChange: ({row, column, changeValue}) => {
        },
      },
    };
  },
  mounted() {
    this.loadFilters();
    this.init();

    // Add keyboard event listener for shortcuts
    document.addEventListener('keydown', this.handleKeyPress);
  },

  beforeDestroy() {
    // Clean up event listener
    document.removeEventListener('keydown', this.handleKeyPress);
  },
  watch: {
    '$route'(to, from) {
      // Handle route changes (e.g., direct navigation, back button)
      if (to.params.id) {
        this.showUserTable = true;
        this.init(to.params.id);
      } else {
        this.showUserTable = false;
        this.init();
      }
    }
  },
  computed: {
    userData() {
      const letPaymentUserData = this.payments.filter((payment) => {
        if(payment.user) {
          return true;
        }
      }).map((payment) => {
        if(payment && payment.user) {
          if (payment.user.stripe_connect) {
            payment.user.stripe_connect_status = payment.user.stripe_connect?.status;
          }
          return payment.user;
        }
        return {};
      });
      return letPaymentUserData;
    },

    filteredUserData() {
      let filtered = this.userData;

      // Filter by Stripe status
      if (this.filters.stripeStatus !== 'all') {
        filtered = filtered.filter(user => {
          // Find the payment data for this user to check ticket timestamps
          const userPayment = this.payments.find(payment => payment.user && payment.user.id === user.id);
          const status = this.getStripeConnectStatus(user, userPayment);
          
          switch (this.filters.stripeStatus) {
            case 'connected':
              return status === 'connected';
            case 'pending':
              return status === 'pending';
            case 'hybrid':
              return status === 'hybrid';
            case 'off':
              return !status || status === null;
            default:
              return true;
          }
        });
      }

      // Filter by bank details
      if (this.filters.bankDetails !== 'all') {
        filtered = filtered.filter(user => {
          const hasBankDetails = user.account_details && 
            user.account_details.account_name && 
            user.account_details.account_name !== 'No account details available';
          
          switch (this.filters.bankDetails) {
            case 'has':
              return hasBankDetails;
            case 'missing':
              return !hasBankDetails;
            default:
              return true;
          }
        });
      }

      // Apply view filters
      switch (this.filters.view) {
        case 'stripe-only':
          filtered = filtered.filter(user => {
            const userPayment = this.payments.find(payment => payment.user && payment.user.id === user.id);
            const status = this.getStripeConnectStatus(user, userPayment);
            return status === 'connected';
          });
          break;
        case 'hybrid-only':
          filtered = filtered.filter(user => {
            const userPayment = this.payments.find(payment => payment.user && payment.user.id === user.id);
            const status = this.getStripeConnectStatus(user, userPayment);
            return status === 'hybrid';
          });
          break;
        case 'bank-only':
          filtered = filtered.filter(user => {
            return user.account_details && 
              user.account_details.account_name && 
              user.account_details.account_name !== 'No account details available';
          });
          break;
        case 'both':
          filtered = filtered.filter(user => {
            const userPayment = this.payments.find(payment => payment.user && payment.user.id === user.id);
            const status = this.getStripeConnectStatus(user, userPayment);
            const hasStripe = status === 'connected';
            const hasBankDetails = user.account_details && 
              user.account_details.account_name && 
              user.account_details.account_name !== 'No account details available';
            return hasStripe && hasBankDetails;
          });
          break;
        default:
          // Default view - no additional filtering
          break;
      }

      return filtered;
    },

    hasActiveFilters() {
      return this.filters.stripeStatus !== 'all' || 
             this.filters.bankDetails !== 'all' || 
             this.filters.view !== 'default';
    },

    currentStripeConnectStatus() {
      if (!this.user || !this.payments || this.payments.length === 0) {
        return null;
      }
      return this.getStripeConnectStatus(this.user, this.payments[0]);
    },

    eventData() {
      // const letEventData = this.payments.filter((payment) => {
      //   if(payment.event) {
      //     return true;
      //   }
      // }).map((payment) => {
      //   if(payment && payment.event) {
      //     return payment.event;
      //   }
      // });
      if (this.payments) {
        return this.payments;
      }
      return [];
    },
  },
  methods: {
    getCurrencyChipClass: function(currencySymbol) {
      // Map currency symbols to chip classes
      const currencyMap = {
        '£': 'gbp',
        '$': 'usd',
        '€': 'eur',
        'C$': 'cad',
        'A$': 'aud',
        '¥': 'jpy',
        'CHF': 'chf'
      };
      
      // Find the matching currency
      for (const [symbol, chipClass] of Object.entries(currencyMap)) {
        if (currencySymbol === symbol) {
          return `Chip Chip--${chipClass}`;
        }
      }
      
      // Default fallback
      return 'Chip Chip--default';
    },

    getOverviewCurrencyChip: function() {
      if (!this.overview || !this.overview.totalPrice) {
        return [{ symbol: '£', class: this.getCurrencyChipClass('£') }];
      }

      const totalPrice = this.overview.totalPrice;
      const currencyChips = [];
      
      // Check for UK (GBP)
      if (totalPrice.UK && totalPrice.UK > 0) {
        currencyChips.push({ symbol: '£', class: this.getCurrencyChipClass('£') });
      }
      
      // Check for EU (Euro)
      if (totalPrice.EU && totalPrice.EU > 0) {
        currencyChips.push({ symbol: '€', class: this.getCurrencyChipClass('€') });
      }
      
      // Check for US (USD)
      if (totalPrice.US && totalPrice.US > 0) {
        currencyChips.push({ symbol: '$', class: this.getCurrencyChipClass('$') });
      }
      
      // Return all found currencies, or default to GBP if none found
      return currencyChips.length > 0 ? currencyChips : [{ symbol: '£', class: this.getCurrencyChipClass('£') }];
    },

    getEarliestTicketTimestamp: function(tickets) {
      if (!tickets || tickets.length === 0) {
        return null;
      }

      const timestamps = tickets
        .map(ticket => ticket.timestamp)
        .filter(timestamp => timestamp) // Filter out null/undefined timestamps
        .sort();

      return timestamps.length > 0 ? timestamps[0] : null;
    },

    getStripeConnectStatus: function(user, payment) {
      // If no stripe_connect data, return null
      if (!user || !user.stripe_connect) {
        return null;
      }

      const stripeStatus = user.stripe_connect.status;
      const stripeUpdatedAt = user.stripe_connect.updated_at;

      // If status is 0 (Pending), always return 'pending'
      if (stripeStatus === 0) {
        return 'pending';
      }

      // If status is 1 (Connected), check for hybrid condition
      if (stripeStatus === 1) {
        // If no payment data or no tickets, return 'connected'
        if (!payment || !payment.tickets || payment.tickets.length === 0) {
          return 'connected';
        }

        // Get the earliest ticket timestamp
        const earliestTicketTimestamp = this.getEarliestTicketTimestamp(payment.tickets);
        
        // If no ticket timestamps available, return 'connected'
        if (!earliestTicketTimestamp) {
          return 'connected';
        }

        // Compare timestamps
        const ticketDate = new Date(earliestTicketTimestamp);
        const stripeDate = new Date(stripeUpdatedAt);

        // If earliest ticket timestamp is prior to Stripe Connect updated date, return 'hybrid'
        if (ticketDate < stripeDate) {
          return 'hybrid';
        }

        // Otherwise, return 'connected'
        return 'connected';
      }

      // For any other status, return null
      return null;
    },

    init: function (userId = false) {
      let vm = this;
      if (vm.showCurrent) {
        let url = vm.baseUrl + "/einstein/payments/due";
        // Check if the current route matches /payments/past/:id
        if (/^\/payments\/past\/\d+$/.test(vm.$route.path)) {
          url = vm.baseUrl + "/einstein/payments/past";
        }

        vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');
        if (vm.$route.params.id || userId) {
          const nextUserId = userId ? userId : vm.$route.params.id;
          url += "/" + nextUserId;
        }
        let postData = {
          venue: vm.venueId
        };

        // Get payments for this company
        vm.axiosInstance
          .post(url, postData)
          .then(function (response) {
            if (response.data) {
              // reset error
              vm.asyncFormError = false;
              if (response.data.status === 'error') {
                vm.asyncFormError = true;
                vm.errorMessage = response.data.message;
              } else {
                vm.payments = response.data.payments;
                vm.overview = {
                  totalOrders: response.data.payments.length,
                  totalPrice: response.data.totalOwed
                }

                if (vm.$route.params.id || userId) {
                  vm.showUserTable = true;
                  vm.columnSource = vm.eventColumns;
                  // copy of data
                  vm.dataSource = clone(vm.eventData);
                  // add total row at end
                  vm.dataSource.push({
                    id: "Total",
                    name: "",
                    date: "",
                    currency_symbol: "",
                    price: "",
                    sold: "",
                    owed: `£${response.data.totalOwed.UK}`,
                  });
                } else {
                  vm.columnSource = vm.userColumns;
                  vm.dataSource = vm.filteredUserData;
                  
                  // Focus the first "View Payments" button after data loads
                  vm.$nextTick(() => {
                    vm.focusFirstViewPaymentsButton();
                  });
                }

                if (response.data.user) {
                  vm.user = response.data.user;
                  vm.user.stripe_connect_status = response.data.user.stripe_connect?.status;
                  
                  // On individual payment pages, automatically fetch account details
                  if (vm.showUserTable) {
                    vm.getAccountDetails(response.data.user);
                  }
                }
              }
            } else {
              console.log("nada", response);
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.asyncFormError = true;
            vm.errorMessage = error;
          });
      }
    },

    focusFirstViewPaymentsButton: function() {
      // Only focus if we're on the main payments list (not individual user view)
      if (this.showUserTable) {
        return;
      }
      
      // Try multiple methods to find and focus the first button
      this.$nextTick(() => {
        // Method 1: Try using ref
        if (this.$refs.firstViewPaymentsButton) {
          this.$refs.firstViewPaymentsButton.focus();
          return;
        }
        
        // Method 2: Find by data attribute
        const firstButton = document.querySelector('[data-view-payments-button][data-row-index="0"]');
        if (firstButton) {
          firstButton.focus();
          return;
        }
        
        // Method 3: Find first "View Payments" button in the table
        const tableElement = this.$refs.paymentsDueElement;
        if (tableElement && tableElement.$el) {
          const firstViewButton = tableElement.$el.querySelector('a.Button');
          if (firstViewButton && firstViewButton.textContent.trim() === 'View Payments') {
            firstViewButton.focus();
          }
        }
      });
    },

    getAccountDetails: function (row) {
      const vm = this;

      let url = vm.baseUrl + "/einstein/user/account-details";
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      let postData = {
        userId: row.id
      };

      // Get account details for this user
      vm.axiosInstance
        .post(url, postData)
        .then(function (response) {
          if (response.data) {
            console.log('Account details response:', response.data);
            if (response.data.status === 'error') {
              // Don't set asyncFormError for account details failures
              console.log('Account details not available for user:', row.id);
              vm.currentAccountDetails = {
                userId: row.id,
                account_name: 'No account details available',
                account_number_decrypted: null,
                sort_code_decrypted: null
              };
            } else if (response.data.data) {
              vm.currentAccountDetails = {
                userId: row.id,
                account_name: response.data.data.account_name || 'No account name available',
                account_number_decrypted: response.data.data.account_number_decrypted || null,
                sort_code_decrypted: response.data.data.sort_code_decrypted || null
              };
            } else {
              // No data returned
              vm.currentAccountDetails = {
                userId: row.id,
                account_name: 'No account details available',
                account_number_decrypted: null,
                sort_code_decrypted: null
              };
            }
          } else {
            console.log("No response data for account details");
            vm.currentAccountDetails = {
              userId: row.id,
              account_name: 'No account details available',
              account_number_decrypted: null,
              sort_code_decrypted: null
            };
          }
        })
        .catch(function (error) {
          // Don't set asyncFormError for account details failures
          console.log('Account details API error (non-critical):', error);
          vm.currentAccountDetails = {
            userId: row.id,
            account_name: 'No account details available',
            account_number_decrypted: null,
            sort_code_decrypted: null
          };
        });
    },

    renderAccountDetailsCell: function ({row}, h) {
      const vm = this;
      
      // Check if we have account details (either from row or current user)
      let hasAccountDetails = row.account_details || (vm.currentAccountDetails && vm.currentAccountDetails.userId === row.id);
      
      if (hasAccountDetails) {
        let accountName, accountNumber, sortCode;
        
        if (row.account_details) {
          // Use obfuscated details from row
          accountName = row.account_details.account_name;
          accountNumber = row.account_details.account_number_obfuscated;
          sortCode = row.account_details.sort_code_obfuscated;
        }
        
        // Overwrite with decrypted details from the main scope if this is the current user
        if (vm.currentAccountDetails && vm.currentAccountDetails.userId === row.id) {
          accountName = vm.currentAccountDetails.account_name;
          accountNumber = vm.currentAccountDetails.account_number_decrypted;
          sortCode = vm.currentAccountDetails.sort_code_decrypted;
        }

        // Apply opacity if Stripe Connect is connected
        const opacityStyle = row.stripe_connect_status === 1 ? 'opacity: 0.5;' : '';

        // On individual payment pages, show redacted-looking bank details
        if (vm.showUserTable) {
          const redactedStyle = 'font-family: monospace; background: #666; color: #666; padding: 2px 4px; border-radius: 3px;';
          const noDetailsStyle = 'font-style: italic; color: #999;';
          
          const children = [
            h('div', {
              style: accountName === 'No account details available' ? noDetailsStyle : ''
            }, accountName)
          ];
          
          if (accountNumber && accountNumber !== 'No account details available') {
            children.push(h('div', { style: redactedStyle }, accountNumber));
          }
          
          if (sortCode && sortCode !== 'No account details available') {
            children.push(h('div', {}, sortCode));
          }
          
          return h('span', { style: opacityStyle }, children);
        }

        // On main payment list, hide the View button
        return h('span', { style: opacityStyle }, [
          accountName,
          h('br'),
          accountNumber,
          h('br'),
          sortCode
        ]);
      }
      
      // No account details available
      return h('span', { style: 'font-style: italic; color: #999;' }, 'No account details available');
    },

    handleKeyPress: function(event) {
      // Only handle shortcuts when user table is shown
      if (!this.showUserTable) return;
      
      // Check if user is typing in an input field
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return;
      
      switch(event.key) {
        case '1':
          this.copyEmail();
          break;
        case '2':
          this.copyAccountNumber();
          break;
        case '3':
          this.copyAmount();
          break;
        case '4':
          this.copyToClipboard();
          break;
        case 'p':
        case 'P':
          event.preventDefault();
          this.markAsPaid();
          break;
      }
    },

    copyEmail: function() {
      if (this.user && this.user.email) {
        navigator.clipboard.writeText(this.user.email).then(() => {
          this.lastPressedKey = '1';
          this.copiedValue = this.user.email;
          this.clearCopyIndicator();
        }).catch(() => {
          // Fallback for older browsers
          this.fallbackCopyToClipboard(this.user.email);
          this.lastPressedKey = '1';
          this.copiedValue = this.user.email;
          this.clearCopyIndicator();
        });
      }
    },

    copyAccountNumber: function() {
      if (this.currentAccountDetails && this.currentAccountDetails.account_number_decrypted) {
        const accountNumber = this.currentAccountDetails.account_number_decrypted;
        navigator.clipboard.writeText(accountNumber).then(() => {
          this.lastPressedKey = '2';
          this.copiedValue = accountNumber;
          this.clearCopyIndicator();
        }).catch(() => {
          this.fallbackCopyToClipboard(accountNumber);
          this.lastPressedKey = '2';
          this.copiedValue = accountNumber;
          this.clearCopyIndicator();
        });
      } else {
        // No account number available
        const message = 'No account number available';
        navigator.clipboard.writeText(message).then(() => {
          this.lastPressedKey = '2';
          this.copiedValue = message;
          this.clearCopyIndicator();
        }).catch(() => {
          this.fallbackCopyToClipboard(message);
          this.lastPressedKey = '2';
          this.copiedValue = message;
          this.clearCopyIndicator();
        });
      }
    },

    copyAmount: function() {
      console.log('copyAmount called, overview:', this.overview);
      
      if (this.overview && this.overview.totalPrice) {
        console.log('totalPrice:', this.overview.totalPrice);
        
        let amount = '';
        // Check for UK amount first
        if (this.overview.totalPrice.UK && parseFloat(this.overview.totalPrice.UK) > 0) {
          amount = this.overview.totalPrice.UK;
        } 
        // Check for EU amount
        else if (this.overview.totalPrice.EU && parseFloat(this.overview.totalPrice.EU) > 0) {
          amount = this.overview.totalPrice.EU;
        } 
        // Check for US amount
        else if (this.overview.totalPrice.US && parseFloat(this.overview.totalPrice.US) > 0) {
          amount = this.overview.totalPrice.US;
        }
        // If no specific currency amounts, try to get any available amount
        else {
          const totalOwed = this.overview.totalPrice;
          if (totalOwed.UK) amount = totalOwed.UK;
          else if (totalOwed.EU) amount = totalOwed.EU;
          else if (totalOwed.US) amount = totalOwed.US;
        }
        
        console.log('Calculated amount:', amount);
        
        if (amount) {
          navigator.clipboard.writeText(amount).then(() => {
            this.lastPressedKey = '3';
            this.copiedValue = amount;
            this.clearCopyIndicator();
            console.log('Amount copied successfully:', amount);
          }).catch((error) => {
            console.log('Clipboard API failed, using fallback:', error);
            this.fallbackCopyToClipboard(amount);
            this.lastPressedKey = '3';
            this.copiedValue = amount;
            this.clearCopyIndicator();
          });
        } else {
          console.log('No amount found to copy');
        }
      } else {
        console.log('No overview or totalPrice available');
      }
    },

    fallbackCopyToClipboard: function(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
    },

    clearCopyIndicator: function() {
      setTimeout(() => {
        this.lastPressedKey = null;
        this.copiedValue = '';
      }, 3000); // Clear after 3 seconds
    },

    loadFilters: function() {
      try {
        const savedFilters = localStorage.getItem('payments-filters');
        if (savedFilters) {
          this.filters = { ...this.filters, ...JSON.parse(savedFilters) };
        }
      } catch (error) {
        console.log('Error loading filters:', error);
      }
    },

    saveFilters: function() {
      try {
        localStorage.setItem('payments-filters', JSON.stringify(this.filters));
      } catch (error) {
        console.log('Error saving filters:', error);
      }
    },

    applyFilters: function() {
      this.saveFilters();
      // Update the data source with filtered data
      if (!this.showUserTable) {
        this.dataSource = this.filteredUserData;
        // Focus the first button after filters are applied
        this.$nextTick(() => {
          this.focusFirstViewPaymentsButton();
        });
      }
    },

    clearFilters: function() {
      this.filters = {
        stripeStatus: 'all',
        bankDetails: 'all',
        view: 'default'
      };
      this.saveFilters();
      this.applyFilters();
    },

    copyToClipboard: function () {
      let target = this.$refs.paymentsDueElement.$el;
      
      // Create a clone of the table to modify for copying
      let tableClone = target.cloneNode(true);
      
      // Find the currency column index by looking for the header
      let headerRow = tableClone.querySelector('thead tr') || tableClone.querySelector('tr');
      let currencyColumnIndex = -1;
      
      if (headerRow) {
        let headerCells = headerRow.children;
        for (let i = 0; i < headerCells.length; i++) {
          let headerContent = headerCells[i].textContent || headerCells[i].innerText;
          if (headerContent.trim() === 'Currency') {
            currencyColumnIndex = i;
            break;
          }
        }
      }
      
      // Hide the entire currency column (header and all data cells)
      if (currencyColumnIndex !== -1) {
        let allRows = tableClone.querySelectorAll('tr');
        allRows.forEach(row => {
          let cells = row.children;
          if (cells[currencyColumnIndex]) {
            cells[currencyColumnIndex].style.display = 'none';
          }
        });
      }

      // Remove inline height and width styles that cause excessive spacing when pasted
      let allElements = tableClone.querySelectorAll('*');
      allElements.forEach(element => {
        if (element.style.height) {
          element.style.height = '';
        }
        if (element.style.minHeight) {
          element.style.minHeight = '';
        }
        if (element.style.maxHeight) {
          element.style.maxHeight = '';
        }
        if (element.style.lineHeight) {
          element.style.lineHeight = '';
        }
        if (element.style.width) {
          element.style.width = '';
        }
        if (element.style.minWidth) {
          element.style.minWidth = '';
        }
        if (element.style.maxWidth) {
          element.style.maxWidth = '';
        }
      });
      
      // Temporarily replace the original table with the modified clone
      let originalParent = target.parentNode;
      let originalNextSibling = target.nextSibling;
      originalParent.insertBefore(tableClone, originalNextSibling);
      target.style.display = 'none';
      
      // Copy the modified table
      let range = document.createRange();
      range.selectNode(tableClone);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      
      // Restore the original table
      originalParent.removeChild(tableClone);
      target.style.display = '';
      window.getSelection().removeAllRanges();

      // Update UI indicator
      this.lastPressedKey = '4';
      this.clearCopyIndicator();
    },

    markAsPaid: function () {
      let vm = this;
      // Set visual indicator for keyboard shortcut
      vm.lastPressedKey = 'p';
      vm.clearCopyIndicator();
      
      let url = vm.baseUrl + "/einstein/payments/mark-as-paid";
      const eventIds = (vm.payments || [])
        .map(payment => payment && payment.id)
        .filter(id => id !== undefined && id !== null && id !== 'Total');

      const derivedUserId = vm.user?.id ||
        vm.$route.params.id ||
        (vm.payments && vm.payments[0] && vm.payments[0].user && vm.payments[0].user.id);

      const shouldStayOnUserView = vm.showUserTable && derivedUserId;

      if (!derivedUserId || eventIds.length === 0) {
        if (shouldStayOnUserView) {
          vm.init(derivedUserId);
        } else {
          vm.init();
        }
        return Promise.resolve();
      }

      let postData = {
        userId: derivedUserId,
        eventIds: eventIds,
      };

      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      // Get payments for this company
      return vm.axiosInstance
        .post(url, postData)
        .then(function (response) {
          if (response.data) {
            // reset error
            vm.asyncFormError = false;
            console.log(response.data);
            if (response.data.status === 'error') {
              vm.asyncFormError = true;
              vm.errorMessage = response.data.message;
            } else {
              console.log(response.data.response);
              if (shouldStayOnUserView) {
                // Ensure route is correct if we're staying on user view
                if (vm.$route.path !== `/payments/due/${derivedUserId}`) {
                  vm.$router.push(`/payments/due/${derivedUserId}`);
                }
                vm.init(derivedUserId);
              } else {
                // Navigate back to main payments list if not staying on user view
                if (vm.$route.path !== '/payments/due') {
                  vm.$router.push('/payments/due');
                }
                vm.init();
              }
            }
          } else {
            console.log("nada", response);
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.asyncFormError = true;
          vm.errorMessage = error.toString();
        });
    },
    transferFunds: function (userId, amount, eventId, ticketCode) {
      let vm = this;
      let url = vm.baseUrl + "/stripe/connect/transfer-funds";
      let postData = {
        userId: userId,
        amount: amount.toFixed(2),
        eventId: eventId,
        ticketCode: ticketCode
      };

      // Get payments for this company
      vm.axiosInstance
        .post(url, postData)
        .then(function (response) {
          if (response.data) {
            // reset error
            vm.asyncFormError = false;
            console.log(response.data);
            if (response.data.status === 'error') {
              vm.asyncFormError = true;
              vm.errorMessage = response.data.message;
            } else {
              console.log(response.data.response);
            }
          } else {
            console.log("nada", response);
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.asyncFormError = true;
          vm.errorMessage = error.toString();
        });
    },
  },
};
</script>
